<template>
  <div class="about" v-on:scroll="handleScroll(event)" style="  overflow: hidden;">
    <div id="homeside">
      <a href="https://www.facebook.com/kingstonecy1986/">
      <img src="./../assets/icon-fb/icon-fb-m.png"
            srcset="./../assets/icon-fb/icon-fb-m@2x.png 2x,
                   ./../assets/icon-fb/icon-fb-m@3x.png 3x"
            class="icon">
      </a>
      <a href="mailto:cs@kingstonecy.com.tw" target="_blank">      
        <img src="./../assets/icon-mail/icon-mail-m.png"
          srcset="./../assets/icon-mail/icon-mail-m@2x.png 2x,
                  ./../assets/icon-mail/icon-mail-m@3x.png 3x"
          class="icon"></a>
    </div> 
    <div class="container">
      <div class="article">
        <ul style="margin-bottom: 35px;">
          金石建築品質獲得國際ISO品質認證<br/>
         【創辦人 柯金龍 前董事長】
          <li id="articleanimations_1" >榮獲第五、六屆嘉義市不動產公會理事長、第十屆嘉義市商業會理事長</li>
         【現任 柯建利 董事長】
          <li id="articleanimations_1">創辦人柯金龍前董事長榮膺第十屆嘉義市商業會理事長</li>
          <li id="articleanimations_1">嘉義市不動產開發商業同業公會理事</li>
          <li id="articleanimations_1" >第十屆嘉義市不動產公會候補監事</li>
          <li id="articleanimations_1" >台灣省不動產開發商業公會聯合會會員代表</li>
          <li id="articleanimations_1" >華人公益節公益大使</li>
          <li id="articleanimations_1" >嘉義市政府市政顧問</li>
          <li id="articleanimations_1" >台灣工商總會－國際經貿委員會、建築建材委員會常務委員</li>
         【金石建設獎項】
          <li id="articleanimations_1" >國家建築金質獎－國家優良建商、規劃設計獎、施工品質獎</li>
          <li id="articleanimations_1">嘉義市109年優良工地評選－優良</li>
          <li id="articleanimations_1">《style master》怪物祭－怪物企業形象獎</li>
          <li id="articleanimations_1">台灣百大品牌－最具影響力品牌－建設居家類</li>
          <li id="articleanimations_1">金峰獎－十大傑出企業、十大傑出領導人</li>
          <li id="articleanimations_1">金炬獎－十大績優企業、十大績優經理人</li>
          <li id="articleanimations_1">國家建築金獎–金獅獎</li>
          <li id="articleanimations_1">體育推手獎－贊助類金質獎</li>
          <li id="articleanimations_1">台日卓越創業家大賞–中小企業組</li>
          <li id="articleanimations_1">台灣誠信品牌–誠信建商認證</li>
        </ul>
        <p id="articleanimations_2">
          金石建設秉持在地深耕、永續經營、誠信踏實的理念，在嘉義地區選擇最好的地段蓋最好的房子。因嘉義屬地震帶，我們對建築的施工品質、結構安全特別注重，別人用5分鋼筋，我們就用7分鋼筋，地基全採用大樓結構筏式基礎施工。
        <br><br>
          對於客戶的承諾，我們說到做到，地段開發、格局規劃、建材品質、建美外觀，我們皆全方位考慮周到、要求完美，所以每座金石的建築都能呈現最完美姿態。作品一出，往往在短時間銷售一空。我們的驕傲，必成為嘉義人的驕傲，成為您的驕傲。
        </p>
      </div>
      <div class="figure">
          <!-- <img src="../assets/about-pic1/about-pic1.png" id="about-pic1"> -->
          <img src="../assets/about-pic1/about-pic1.png"
              srcset="../assets/about-pic1/about-pic1@2x.png 2x,
                      ../assets/about-pic1/about-pic1@3x.png 3x"
              class="about-pic1" id="articleanimations_3">
      </div>
    </div>
    <svg xmlns="http://www.w3.org/2000/svg" v-if="width < 1600" :class="'stroke '+ this.className_theLINE " 
         width="1280" height="279" viewBox="0 0 1280 279" style="margin-left: 80px; margin-top: -50px;">
      <path fill="none" fill-rule="evenodd" stroke="#BBB" stroke-linecap="square" d="M1 0v155.923h1278V279"/>
    </svg>
    <svg xmlns="http://www.w3.org/2000/svg" v-else-if="(1600 <= width) && (width <= 1800)" :class="'stroke '+ this.className_theLINE " 
         width="1680" height="379" viewBox="0 0 1680 379" style="margin-left: 80px; margin-top: -170px;">
      <path fill="none" fill-rule="evenodd" stroke="#BBB" stroke-linecap="square" d="M1 0v260.923h1478V379"/>
    </svg>
    <svg xmlns="http://www.w3.org/2000/svg" v-else-if="1800 < width" :class="'stroke '+ this.className_theLINE " 
         width="1920" height="279" viewBox="0 0 1920 279" style="margin-left: 80px; margin-top: -50px;">
      <path fill="none" fill-rule="evenodd" stroke="#BBB" stroke-linecap="square" d="M1 0v155.923h1678V279"/>
    </svg>
    <span class="subtitle">服務項目</span>
    <div class="iconbanner">
      <div class="icon-item" id="service-buy">
        <svg xmlns="http://www.w3.org/2000/svg"  class="stroke"
             width="162" height="162" viewBox="0 0 162 162">
            <g fill="none" fill-rule="evenodd">
                <path :class="'pathicon ' +this.className_theIcon" id="theIcon1line1" stroke="#A89A80" stroke-width="1.501" d="M98.697 91.782v-13.2l7.664 7.296 6.412-6.104L79.43 48.037 46.09 79.774l6.411 6.104 7.664-7.296v24.387H82.42"/>
                <path :class="'pathicon ' +this.className_theIcon" id="theIcon1line2" stroke="#A89A80" stroke-width="1.501" d="M60.165 78.582l19.023-18.107 19.51 18.107"/>
                <path :class="'pathicon ' +this.className_theIcon" id="theIcon1line3" stroke="#A89A80" stroke-width="1.501" d="M72.439 90.398h13.844V77.221H72.439zM79.362 77.221v13.177M86.283 83.81H72.44"/>
                <g stroke="#A89A80" stroke-width="1.545">
                    <path :class="'pathicon ' +this.className_theIcon" id="theIcon1line4" d="M116.135 109.022c0 9.521-7.72 17.24-17.24 17.24-9.522 0-17.24-7.719-17.24-17.24 0-9.52 7.718-17.24 17.24-17.24 9.52 0 17.24 7.72 17.24 17.24z"/>
                    <path :class="'pathicon ' +this.className_theIcon" id="theIcon1line5" d="M103.716 103.44s-3.009-4.94-7.193-2.325c-1.032.644-1.758 1.64-2.107 2.805-.808 2.697.415 4.75 5.914 5.085 2.333.142 4.115 2.292 3.633 4.58-.709 3.352-5.241 5.541-8.445 3.006-.533-.422-1.771-1.824-1.771-2.55M98.895 97.444v2.913M98.895 117.686v2.914"/>
                </g>
                <path :class="'pathfig ' + this.className_theFIG" id="theFIG1" stroke="#BBB" stroke-linecap="square" d="M1 1h160v160H1z"/>
            </g>
        </svg>
        <span class="icon-title">買屋</span>
      </div>
      <div class="icon-item" id="service-sales">
        <svg xmlns="http://www.w3.org/2000/svg"  class="stroke"
             width="162" height="162" viewBox="0 0 162 162">
            <g fill="none" fill-rule="evenodd">
                <path :class="'pathfig ' + this.className_theFIG" id="theFIG2" stroke="#BBB" stroke-linecap="square" d="M1 1h160v160H1z"/>
                <g stroke="#A89A80" stroke-width="1.49">
                    <path :class="'pathicon ' +this.className_theIcon" id="theIcon2line1" d="M107.306 119.234h13.867V97.41h-13.867zM107.306 101.449s-12.583-3.425-20.913-1.718c0 0-4.094.537-11.347 8.59 0 0-3.886 4.02.177 5.566 1.929.734 4.158.245 5.66-1.088l6.554-5.82"/>
                    <path :class="'pathicon ' +this.className_theIcon" id="theIcon2line2" d="M74.154 113.29s-13.558-1.58-15.834-1.99c-3.807-.686-14.997-.285-8.681 4.412 6.316 4.697 22.386 9.322 26.383 9.836 3.727.478 11.76.446 18.79-5.03 2.014-1.57 4.142-3.017 6.475-4.151 2.218-1.078 4.638-1.928 6.019-1.39M63.962 69.493V91.42h34.646V69.493l6.89 6.56 5.766-5.49-29.98-28.534-29.978 28.535 5.764 5.489z"/>
                    <path :class="'pathicon ' +this.className_theIcon" id="theIcon2line3" d="M63.962 69.493l17.104-16.281 17.542 16.28"/>
                    <path :class="'pathicon ' +this.className_theIcon" id="theIcon2line4" d="M74.999 80.118h12.447v-11.85H74.999zM81.222 68.27v11.848M87.446 74.194H74.999"/>
                </g>
            </g>
        </svg>
        <span class="icon-title">賣屋</span>
      </div>
      <div class="icon-item" id="service-construst">
          <svg xmlns="http://www.w3.org/2000/svg" class="stroke"
               xmlns:xlink="http://www.w3.org/1999/xlink" width="162" height="162" viewBox="0 0 162 162">
              <defs>
                  <path id="a" d="M0 .727h87.637V71H0z"/>
              </defs>
              <g fill="none" fill-rule="evenodd">
                  <path :class="'pathfig ' + this.className_theFIG" id="theFIG3" stroke="#BBB" stroke-linecap="square" d="M1 1h160v160H1z"/>
                  <g transform="translate(40 51.67)">
                      <mask id="b" fill="#fff">
                          <use :class="'pathicon ' +this.className_theIcon" id="theIcon3m" xlink:href="#a"/>
                      </mask>
                      <path :class="'pathicon ' +this.className_theIcon" id="theIcon3p" stroke="#A89A80" stroke-width="1.419" d="M9.737 70.291h5.687V.727H9.737zM0 70.291h87.638" mask="url(#b)"/>
                  </g>
                  <path :class="'pathicon ' +this.className_theIcon" id="theIcon3line1" stroke="#A89A80" stroke-width="1.419" d="M73.076 92.154h2.932v-2.932h-2.932zM73.076 98.813h2.932v-2.93h-2.932zM73.076 105.471h2.932v-2.93h-2.932zM73.076 112.13h2.932v-2.932h-2.932zM73.076 118.788h2.932v-2.93h-2.932zM79.986 92.154h2.931v-2.932h-2.931zM73.076 85.632h2.932v-2.93h-2.932zM79.986 85.632h2.931v-2.93h-2.931zM79.986 98.813h2.931v-2.93h-2.931zM79.986 105.471h2.931v-2.93h-2.931zM79.986 112.13h2.931v-2.932h-2.931zM79.986 118.788h2.931v-2.93h-2.931zM86.895 92.154h2.931v-2.932h-2.931zM86.895 98.813h2.931v-2.93h-2.931zM86.895 105.471h2.931v-2.93h-2.931zM86.895 112.13h2.931v-2.932h-2.931zM86.895 118.788h2.931v-2.93h-2.931zM93.803 92.154h2.932v-2.932h-2.932zM93.803 98.813h2.932v-2.93h-2.932zM93.803 105.471h2.932v-2.93h-2.932zM93.803 112.13h2.932v-2.932h-2.932zM93.803 118.788h2.932v-2.93h-2.932zM67.695 79.11h24.899"/>
                  <path :class="'pathicon ' +this.className_theIcon" id="theIcon3line2" stroke="#A89A80" stroke-width="1.419" d="M88.36 76.024v8.83l13.757.066v37.04H67.695V68.309M67.695 73.882h15.222M102.117 73.882v11.126"/>
                  <g stroke="#A89A80" stroke-width="1.419" :class="'pathicon ' +this.className_theIcon" id="theIcon3-2">
                      <path d="M43.137 52.396h79.56V46.71h-79.56z"/>
                      <path d="M122.697 46.71l-6.89 5.061-6.37-5.062M109.437 46.71l-6.89 5.061-6.37-5.062M96.177 46.71l-6.89 5.061-6.37-5.062M82.917 46.71l-6.89 5.061-6.37-5.062M69.658 46.71l-6.89 5.061-6.37-5.062M56.398 46.71l-6.89 5.061-6.371-5.062"/>
                  </g>
                  <path :class="'pathicon ' +this.className_theIcon" id="theIcon3line3" stroke="#A89A80" stroke-width="1.419" d="M50.048 52.396l5.063 6.89-5.063 6.37M50.048 65.657l5.063 6.889-5.063 6.37"/>
                  <path :class="'pathicon ' +this.className_theIcon" id="theIcon3line4" stroke="#A89A80" stroke-width="1.419" d="M50.048 78.895l5.063 6.889-5.063 6.37M50.048 92.155l5.063 6.889-5.063 6.37M50.048 105.415l5.063 6.889-5.063 6.37"/>
                  <g stroke="#A89A80" stroke-width="1.419" :class="'pathicon ' +this.className_theIcon" id="theIcon3-3">
                      <path d="M114.796 114.949l-6.357 6.695h12.714zM114.614 52.396V81.426c0 .298-.11.85 0 1.132.472 1.198 2.436.725 2.668 2.197.06.39-.026.792-.176 1.159-.596 1.457-2.263 2.307-3.638 1.274-.525-.396-.894-.967-1.177-1.561M73.594 62.844v16.602"/>
                  </g>
              </g>
          </svg>
          <span class="icon-title">工程發包</span>      
      </div>
      <div class="icon-item" id="service-s">
        <svg xmlns="http://www.w3.org/2000/svg" class="stroke"
             width="162" height="162" viewBox="0 0 162 162">
            <g fill="none" fill-rule="evenodd">
                <path :class="'pathfig ' + this.className_theFIG" id="theFIG4" stroke="#BBB" stroke-linecap="square" d="M1 1h160v160H1z"/>
                <g stroke="#A89A80" stroke-width="1.487">
                    <path :class="'pathicon ' +this.className_theIcon" id="theIcon4line1" d="M101.913 53.025h21.53v-2.59h-21.53zM101.913 58.206h21.53v-2.59h-21.53zM101.913 63.387h11.593v-2.591h-11.593zM67.148 88.158S49.182 90.31 55.21 80.984c2.138-3.308-1.875-10.388-1.57-17.586.331-7.813 4.461-18.654 19.204-18.654 0 0 .96.017 2.446.325 8.31 1.723 14.297 8.99 14.716 17.467.241 4.858-1.204 10.905-1.49 15.33-.24 3.715 5.053 5.1 1.594 8.002-2.237 1.876-10.5 2.848-12.966 2.566"/>
                    <path :class="'pathicon ' +this.className_theIcon" id="theIcon4line2" d="M67.452 82.965s.353 2.412-.12 4.53c-.417 1.858-2.404 3.702-4.3 3.538-4.03-.348-14.79-1.187-15.289 6.604v23.574M76.743 82.965s-.319 2.183.058 4.22c.372 2.01 3.112 4.067 5.148 3.897 4.11-.343 14.01-1.17 14.502 6.555v10.737l6.422-11.312h10.653l-13.103 24.61"/>
                    <path :class="'pathicon ' +this.className_theIcon" id="theIcon4line3" d="M62.965 91.038l1.48 2.125c3.502 5.021 11.057 5.23 14.85.41l1.96-2.66M102.873 97.062s.49-7.758 11.979-7.476l6.347-.007s.321 4.23-7.673 7.483M111.615 69.84l-5.244 3.78a.778.778 0 0 1-1.234-.63V69.79h-2.99a3.425 3.425 0 0 1-3.425-3.425V49.263a3.425 3.425 0 0 1 3.424-3.425h21.918a3.424 3.424 0 0 1 3.425 3.425v17.103a3.424 3.424 0 0 1-3.425 3.425l-12.449.048zM60.756 66.76s6.18 2.992 14.412-6.675c0 0 1.716 6.778 8.232 6.528h.002a12.287 12.287 0 0 1 1.03 4.943c0 6.806-5.516 12.322-12.322 12.322-6.805 0-12.323-5.516-12.323-12.322 0-1.702.345-3.322.969-4.797zM57.661 105.113v16.099M87.826 105.113v16.099"/>
                </g>
            </g>
        </svg>
        <span class="icon-title">房屋售後服務</span>
      </div>
      <div class="icon-item" id="service-corperation">
        <svg xmlns="http://www.w3.org/2000/svg" class="stroke"
             width="162" height="162" viewBox="0 0 162 162">
            <g fill="none" fill-rule="evenodd">
                <path :class="'pathfig ' + this.className_theFIG" id="theFIG5" stroke="#BBB" stroke-linecap="square" d="M1 1h160v160H1z"/>
                <g stroke="#A89A80" stroke-width="1.54">
                    <path :class="'pathicon ' +this.className_theIcon" id="theIcon5line1" d="M42.77 58.809s15.866.773 17.886 4.56l-7.018 28.389H42.77V58.809zM54.725 87.36s26.26 30.2 35.984 21.428M79.864 99.85s12.313 16.822 17.428 5.738M86.451 96.84s12.695 16.557 17.838 4.624M60.033 65.89h17.495"/>
                    <path :class="'pathicon ' +this.className_theIcon" id="theIcon5line2" d="M107.418 70.464s-16.708-9.52-22.73-8.044c0 0-9.932 1.857-13.763 11.56 0 0-3.996 9.08 5.285 6.691 2.288-.589 4.363-1.866 5.863-3.69.019-.024.033-.04.039-.05.02-.03 1.41-.798 1.67-.863 2.99-.747 4.932.757 7.27 2.766l16.176 13.901c2.098 1.802 2.734 4.888 1.294 7.25C104.552 106.496 93.4 92.1 93.4 92.1M109.299 95.164l5.563-3.535M127.164 62.841s-14.407-1.307-21.187 3.637l10.593 29.29 10.594-.194V62.841z"/>
                </g>
            </g>
        </svg>
        <span class="icon-title">合作提案</span>
      </div>
    </div>
    <label id="flow-label" :class="'flow-label '+this.className_theFLOW">買賣流程表</label>
    <div class="flowcontainer">
      <div :class="'flow '+this.className_theFLOW">
        <img src="../assets/salesflow/salesflow.png"
          srcset="../assets/salesflow/salesflow@2x.png 2x,
                  ../assets/salesflow/salesflow@3x.png 3x"
          class="salesflow">
      </div>
      <div :class="'flow '+this.className_theFLOW" id="flowdescription">
        <ul style="list-style-type: none; margin-left:-6%;">
          <li>・服務對象：本公司承購戶均適用</li>
          <li>・服務項目條件</li>
          <ul style="list-style-type: none;">
            <li>- 各項建材設備之保養諮詢服務</li>
            <li>- 各項稅捐、地政法令即不動產買賣諮詢服務</li>
            <li>- 承購房屋之裝修建材、裝修工程及結構安全諮詢服務</li>
          </ul>
        </ul>
      </div>
        <!-- <span>即刻與我們聯絡</span> -->
    </div>
  </div>
  
</template>
<script>
export default {
  data(){
    return {    
      width:"",  
      windowscrollY:"",
      className_theLINE:'',
      className_theFIG:'',
      className_theIcon:'',
      className_theFLOW:''
      }
  },
  methods: {
      handleResize() {
        this.width = window.innerWidth;
        this.height = window.innerHeight;
      },
      handleScroll (event) {
        this.windowscrollY = window.scrollY
        // console.log(this.windowscrollY)
        if(this.width < 1600){
        if (this.windowscrollY > 160) {
            this.className_theLINE = 'theLINE'
            this.className_theFIG = 'theFIG'
            this.className_theIcon = 'theIcon'
            // console.log(this.className+'foo')
        // Any code to be executed when the window is scrolled
        }
        if(this.windowscrollY > 915){
              this.className_theFLOW = 'theFLOW'
        }
        }
        else if((1600 <= this.width) && (this.width <= 1800)){
          if (this.windowscrollY > 160) {
              this.className_theLINE = 'theLINE'
              this.className_theFIG = 'theFIG'
              this.className_theIcon = 'theIcon'
          }
          if(this.windowscrollY > 765){
                this.className_theFLOW = 'theFLOW'
          }
        }
        else if(1800 < this.width){
          if (this.windowscrollY > 160) {
              this.className_theLINE = 'theLINE'
              this.className_theFIG = 'theFIG'
              this.className_theIcon = 'theIcon'
          }
          if(this.windowscrollY > 905){
                this.className_theFLOW = 'theFLOW'
          }
        }
      // else console.log('no')
      }
  },
  created () {
      window.addEventListener('resize', this.handleResize)
      this.handleResize();
      window.addEventListener('scroll', this.handleScroll);
  },
  destroyed () {
      window.removeEventListener('resize', this.handleResize)
      window.removeEventListener('scroll', this.handleScroll);
  }
}
</script>
<style scoped>
.about{
  width: 100%;
  height: auto;
  margin:0;
}

#homeside, .article, .figure{
  display: inline-block;
}

#homeside{
  position:relative;
  text-align: center;
  float: left;
  width: 46px;
  height: auto;
  margin: 300px 120px 10px 48px;
}
.icon {
  position:relative;
  height: 28px;
  margin: 9px 18px;
  object-fit: contain;
}
.icon:hover{
  cursor: pointer;
}
.container{
  width: 100%;
  margin:  0;
}
.article{  
  float: left;
  display: block;
  width:32%;
  margin:0;
  }

.article ul {
  /* width: 381px;
  height: 111px; */
  font-size: 15px;
  font-weight: normal;
  font-style: normal;
  font-stretch: normal;
  line-height: 1.7;
  letter-spacing: 1.5px;
  text-align: justify;
  color: #a89a80;
  list-style-type: circle;
  margin-left: -18px;
}
#articleanimations_1{
  opacity: 0;
  animation: showup 1s linear forwards;
  -webkit-animation: showup 1s linear forwards;
  animation-delay: 0.5s;
	-webkit-animation-delay: 0.5s;
}

@keyframes showup{
    0%{
      transform: translateY(10px);
    }
    100% {
        opacity: 1;
        }
    }
p{
  height: 330px;
  font-size: 15px;
  font-weight: normal;
  font-style: normal;
  font-stretch: normal;
  line-height: 1.58;
  letter-spacing: 1.27px;
  text-align: justify;
  color: #7d7d7d;
  opacity: 0;
  animation: showuparticle 1s linear forwards;
  -webkit-animation: showuparticle 1s linear forwards;
  animation-delay: 1.5s;
	-webkit-animation-delay: 1.5s;
}
@keyframes showuparticle{
    0%{
      transform: translateY(14px);
    }
    100% {
        opacity: 1;
        }
    }
.figure{
  margin: -6% 0 0 1%;
  padding-bottom: 40px;
  padding-top: 11%;
  float: right;
  display: block;
  width:47%;
  /* width: 700px;
  height: 520px; */
  background-image: linear-gradient(320deg, #c4c3c283, #dadad9 3%, #ebebeb 18%, #feffffa2, #ffffff);
}
.about-pic1{
  width: 80%;
  height: auto;
  margin-left: 90px;
  margin-bottom: 40px;
  position: relative;
}
#articleanimations_3{
  opacity: 0;
  animation: showup 1.7s ease-in-out forwards;
  -webkit-animation: showup 1.7s ease-in-out forwards;
  animation-delay: 1.3s;
	-webkit-animation-delay: 1.3s;
}
.stroke{
    stroke-dashoffset: 2000;
    stroke-dasharray: 2000;
}
.theLINE{
  animation: circle-draw 2s linear forwards;
  animation-delay: 0s;
	-webkit-animation-delay: 0s;
  -webkit-animation: circle-draw 2s linear forwards;
}
.theFIG{
  animation: circle-draw 4s linear forwards;
  -webkit-animation: circle-draw 4s linear forwards;
}
.theIcon{
  animation: circle-draw  5s linear forwards;
  -webkit-animation: circle-draw 5s linear forwards;
}
#theFIG1{ animation-delay: 1.7s; 	-webkit-animation-delay: 1.7s;}
#theIcon1line1{ animation-delay: 1s; 	-webkit-animation-delay: 1s;}
#theIcon1line2{  animation-delay: 1.4s; 	-webkit-animation-delay: 1.4s;}
#theIcon1line3{ animation-delay: 1.6s; 	-webkit-animation-delay: 1.6s;}
#theIcon1line4{ animation-delay: 1.9s; 	-webkit-animation-delay: 1.9s;}
#theIcon1line5{ animation-delay: 2.1s;	-webkit-animation-delay: 2.1s;}

#theFIG2{ animation-delay: 2.6s; 	-webkit-animation-delay: 2.6s;}
#theIcon2line1{ animation-delay: 1.8s;	-webkit-animation-delay: 1.8s;}
#theIcon2line2{ animation-delay: 2s;	-webkit-animation-delay: 2s;}
#theIcon2line3{ animation-delay: 2.3s;	-webkit-animation-delay: 2.3s;}
#theIcon2line4{ animation-delay: 2.5s;	-webkit-animation-delay: 2.5s;}
#theFIG3{ animation-delay: 3.3s; 	-webkit-animation-delay: 3.3s;}
#theIcon3m{  animation-delay: 2.7s;	-webkit-animation-delay: 2.7s;}
#theIcon3p{  animation-delay: 3s; -webkit-animation-delay: 3s;}
#theIcon3line1{ animation-delay: 3.2s;	-webkit-animation-delay: 3.2s;}
#theIcon3line2{ animation-delay: 3.6s;	-webkit-animation-delay: 3.6s;}
#theIcon3-2{ animation-delay: 4s;	-webkit-animation-delay: 4s;}
#theIcon3line3{ animation-delay: 3.7s;	-webkit-animation-delay: 3.7s;}
#theIcon3line4{ animation-delay: 4s;	-webkit-animation-delay: 4s;}
#theIcon3-3{ animation-delay: 4.2s;	-webkit-animation-delay: 4.2s;}
#theFIG4{ animation-delay: 5s; 	-webkit-animation-delay: 5s;}
#theIcon4line1{ animation-delay: 4.6s;	-webkit-animation-delay: 4.6s;}
#theIcon4line2{ animation-delay: 4.8s;	-webkit-animation-delay: 4.8s;}
#theIcon4line3{ animation-delay: 5.2s;	-webkit-animation-delay: 5.2s;}
#theFIG5{ animation-delay: 6s; 	-webkit-animation-delay: 6s;}
#theIcon5line1{ animation-delay: 6s;	-webkit-animation-delay: 6s;}
#theIcon5line2{ animation-delay: 5.6s;	-webkit-animation-delay: 5.6s;}

@keyframes circle-draw{
    100% {
        stroke-dashoffset: 0;
        }
    }
.subtitle {
  width: 62px;
  height: 68px;
  opacity: 0.84;
  font-size: 28px;
  font-weight: normal;
  font-style: normal;
  font-stretch: normal;
  line-height: normal;
  letter-spacing: 3px;
  color: #a89a80;
  display: block;
  margin: -6% 0 0 85.3%;
}
.iconbanner{
  display: block;
  width: 96%;  
  padding-left: 4%;
  margin-bottom: 10%;
}
.icon-item{
  width: 162px;
  text-align: center;
  display: inline-block;
  margin: 5% 3.2% 3% 3.2%;
}
.icon-title{
  margin-top: 8%;
  display: inline-block;
  font-size: 20px;
  font-weight: normal;
  font-style: normal;
  font-stretch: normal;
  line-height: 1.5;
  letter-spacing: 1.59px;
  text-align: justify;
  color: #7d7d7d;
}
#flow-label{
  text-align: center;
  margin-left: 7.5%;
  width: 173px;
  height: 45px;
  padding: 13px 32px;
  border: solid 1px #bbbbbbcb;
  font-size: 20px;
  font-weight: normal;
  font-style: normal;
  font-stretch: normal;
  line-height: normal;
  letter-spacing: 1.46px;
  text-align: justify;
  color: #d0ad76;
  opacity: 0;
}
#flow-label.theFLOW{  
  animation: showup 1s linear forwards;
  -webkit-animation: showup 1s linear forwards;
  animation-delay: 0.2s;	-webkit-animation-delay: 0.2s;}
.flowcontainer{
  display: block;
  width:100%;  
  height: auto;
  margin: 2.2% 0 0 0;
  padding: 3% 0% 20% 0%;
  background-image: linear-gradient(to top, #c4c3c243, #dadad90b 40%, #feffff1e);
  /* margin-left: -4.8%; */
}
.flow{
  opacity: 0;
  display: inline-block;
  margin: 0 auto 0 9.5%;
  vertical-align: middle;
}
.flow.theFLOW{  
  animation: showup 1s linear forwards;
  -webkit-animation: showup 1s linear forwards;
  animation-delay: 0.7s;	-webkit-animation-delay: 0.7s;}
#flowdescription{
  margin-left: 6.5%;
  width: 530px;
  height: 100%;
  border: solid 1px #bbbbbb;
  padding: 40px 32px;
  font-size: 18px;
  font-weight: normal;
  font-style: normal;
  font-stretch: normal;
  line-height: 1.67;
  letter-spacing: 1.43px;
  text-align: justify;
  color: #7d7d7d;
}

@media screen and (min-width:1600px) and (max-width:1800px){
.article{  
  margin: auto 0% auto 2%;
}
.figure{
  width:50%;
  margin: -7% 0 0 0%;
  padding-bottom: 90px;
  padding-top: 210px;
}
.about-pic1{
  width: 618px;
  height: auto;
  margin-left: 90px;
  margin-bottom: 40px;
  position: relative;
}
.article ul{
  margin-top: 18%;
}
.subtitle {
  margin: -5% 0 0 85.3%;
}
.iconbanner{
  width: 100%;  
  padding-left: 4.5%;
  margin-bottom: 12%;
}

.flow{
  margin: 0 auto 0 12.5%;
}
.flowcontainer{
  padding: 3% 0% 12% 0%;
}
#flowdescription{
  margin-left: 10.5%;
}
}
@media screen and (min-width:1801px){
.article{  
  margin: auto 0% auto 0%;
}
.figure{
  width:50%;
  margin: -6% 0 0 0%;
  padding-bottom: 90px;
  padding-top: 210px;
}
.about-pic1{
  width: 618px;
  height: auto;
  margin-left: 90px;
  margin-bottom: 40px;
  position: relative;
}
.article ul{
  margin-top: 18%;
}
.subtitle {
  margin: -4.5% 0 0 85.3%;
}
.iconbanner{
  width: 100%;  
  padding-left: 10%;
}
#flow-label{ 
  margin-left: 12.5%;
}
.flow{
  margin: 0 auto 0 18.5%;
}
.flowcontainer{
  padding: 3% 0% 12% 0%;
}
#flowdescription{
  margin-left: 10.5%;
}
}
</style>